import React from 'react';
import PropTypes from 'prop-types';

import { ProductCardLayout, BigNumberBox, MessagePropType } from '@ratehub/base-ui';


function ProductCardWithBigNumberBox({ product, ...otherProps }) {
    return (
        <ProductCardLayout
            image={product.image}
            name={product.name}
            topRightElement={(
                <BigNumberBox
                    {...product.bigNumber}
                />
            )}

            details={product.details}
            rightOfDetailsElement={product.callToAction}

            footer={product.footer}
            designationMessage={product.designationMessage}
            messageBanner={product.messageBanner}
            analyticsObject={product.analyticsObject}
            data-test-name="product-card-layout"
            {...otherProps}
        >
            {product.children}
        </ProductCardLayout>
    );
}

ProductCardWithBigNumberBox.propTypes = {
    product: PropTypes.shape({
        image: PropTypes.shape({
            url: PropTypes.string.isRequired,
            alt: MessagePropType.isRequired,
            width: PropTypes.string.isRequired,
            height: PropTypes.string,
        }),
        name: PropTypes.shape({
            message: MessagePropType,
            Component: PropTypes.node,
        }).isRequired,
        bigNumber: PropTypes.object,

        details: PropTypes.node.isRequired,

        callToAction: PropTypes.node,

        children: PropTypes.node,
        footer: PropTypes.node,

        designationMessage: PropTypes.node,
        messageBanner: PropTypes.node,
        analyticsObject: PropTypes.object.isRequired,
    }).isRequired,
};


export default ProductCardWithBigNumberBox;
